"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-range-picker", _vm._g({
    attrs: {
      format: _vm.format,
      "value-format": _vm.valueFormat,
      disabled: _vm.disabled,
      "show-time": _vm.showTime,
      "disabled-date": _vm.disabledDate,
      ranges: _vm.renderRanges,
      "allow-clear": _vm.allowClear,
      "dropdown-class-name": _vm.dropdownClassName
    },
    on: {
      calendarChange: _vm.handleCalendarChange
    },
    model: {
      value: _vm.modelValue,
      callback: function ($$v) {
        _vm.modelValue = $$v;
      },
      expression: "modelValue"
    }
  }, _vm.events));
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;